import React from 'react'

import AreaChart from 'recharts/es6/chart/AreaChart'
import XAxis from 'recharts/es6/cartesian/XAxis'
import YAxis from 'recharts/es6/cartesian/YAxis'
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid'
import Tooltip from 'recharts/es6/component/Tooltip'
import { Area } from 'recharts'
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'

export default class ChartArea extends React.PureComponent {
    render() {
        
        return (
            <ResponsiveContainer>
                <AreaChart
                    data={this.props.data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Area
                        type="monotone"
                        dot={true}
                        dataKey="uv"
                        stroke="#660033"
                        strokeWidth="2"
                        fillOpacity={1}
                        fill="#ff80bf"
                        name="People Joined"
                        isAnimationActive={true}
                    />
                    <Area
                        dot={true}
                        type="monotone"
                        dataKey="pv"
                        stroke="#006600"
                        strokeWidth="2"
                        fillOpacity={0.4}
                        fill="#66ff66"
                        name="Amount Collected"
                        animationBegin={200}
                    />
                </AreaChart>
            </ResponsiveContainer>
        )
    }
}

// export default ChartArea;
